import { createAction } from 'redux-actions';
import {
  INIT, READY, RESTORE, CONSTRUCTED, MEDIA_LOADED, MEDIA_NOT_LOADED,
} from './types';

export const init = createAction(INIT);
export const ready = createAction(READY);
export const restore = createAction(RESTORE);
export const constructed = createAction(CONSTRUCTED);
export const mediaLoaded = createAction(MEDIA_LOADED);
export const mediaNotLoaded = createAction(MEDIA_NOT_LOADED);
